import { Text } from '@mantine/core';
import * as React from 'react';
import {
    DialogSize,
    ResizableDialog,
} from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { PersistableInfo } from '../../../resource/resource-base/persistableResourceTypes';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { ResourceValidationTitleBar } from '../validation/ResourceValidationTitleBar';

export const ResizableDialogWithValidation = ({
    onClose,
    canClose,
    resourceType,
    title,
    disableBackdropClick,
    children,
    actions,
    customButtons,
    dialogSize,
    resourceValidationResult,
    versionMetaDataInfo,
    metaDataInfo,
    style,
}: {
    title: string;
    onClose: () => void;
    canClose: boolean;
    resourceType?: ResourceType | ResourceType[];
    disableBackdropClick: boolean;
    children: React.ReactNode | React.ReactNode[];
    actions?: React.ReactNode | React.ReactNode[];
    customButtons?: React.ReactNode | React.ReactNode[];
    resourceValidationResult?: DetailedValidationResource | DetailedValidationResource[];
    metaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    versionMetaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    dialogSize: DialogSize;
    style?: React.CSSProperties;
}) => {
    return (
        <ResizableDialog
            title={title}
            onClose={onClose}
            canClose={canClose}
            disableBackdropClick={disableBackdropClick}
            dialogSize={dialogSize}
            style={style}
            actions={actions}
            titleBar={
                <ResourceValidationTitleBar
                    resourceValidationResult={resourceValidationResult}
                    resourceType={resourceType}
                    metaDataInfo={metaDataInfo}
                    versionMetaDataInfo={versionMetaDataInfo}
                    customButtons={customButtons}
                >
                    <Text c="dimmed">{title}</Text>
                </ResourceValidationTitleBar>
            }
        >
            {children}
        </ResizableDialog>
    );
};
